export default __webpack_public_path__ + "static/media/lg_fantom.9b335b7a.svg";